import { render, staticRenderFns } from "./payOrdersTGY.vue?vue&type=template&id=4edee264&scoped=true"
import script from "./payOrdersTGY.vue?vue&type=script&lang=js"
export * from "./payOrdersTGY.vue?vue&type=script&lang=js"
import style0 from "./payOrdersTGY.vue?vue&type=style&index=0&id=4edee264&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edee264",
  null
  
)

export default component.exports